// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const userBrucePowerSelector = (state: ApplicationState) => {
    if (!state.context.session.isAuthenticated) {
        return false;
    }
    return !!state.context.session.userRoles.includes("BP_User");
};
